import { httpUrl } from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl85 = `${httpUrl.host}/gy-apartment`

let api = {
  // 招商部分页
  getPagePlatform: `${baseUrl}/platform/agentCommissioner/getPage`,

  // 添加招商部
  addPlatform: `${baseUrl}/platform/agentCommissioner/add`,

  // 删除招商部
  deletePlatform: `${baseUrl}/platform/agentCommissioner/delete`,

  // 经纪人分页
  getPageAgentPerson: `${baseUrl}/platform/agentPerson/getPageAgentPerson`,

  // 删除经纪人
  deleteAgent: `${baseUrl}/platform/agentPerson/deleteAgent`,

  // 经纪人申请
  getPageApply: `${baseUrl}/platform/agentPerson/getPageApply`,

  // 经纪人处理
  handleApply: `${baseUrl}/platform/agentPerson/handleApply`,

  // 经纪人列表
  getAgentPersonList: `${baseUrl}/platform/agentPerson/getList`,

  // 获取人员列表
  getPersonList: `${baseUrl85}/person/getList`,

  // 获取签订人列表
  getEnterpriseManagerList: `${baseUrl}/contractManager/getEnterpriseManagerList`,

  // 添加客户
  addCustom: `${baseUrl}/customManager/add`,

  // 获取客户详情
  getCustomByCode: `${baseUrl}/customManager/getByCode`,

  // 修改客户
  updateCustomByCode: `${baseUrl}/customManager/updateByCode`,

  // 获取客户分页
  getCustomPage: `${baseUrl}/customManager/getPage`,

  // 导出客户
  exportCustom: `${baseUrl}/customManager/export`,

  // 查询空置房源列表
  getVacancyRoomInfo: `${baseUrl}/customManager/getVacancyRoomInfo`,

  // 发布房源
  addRoom: `${baseUrl}/platform/agentRoom/add`,

  // 房源分页
  getPageByCondition: `${baseUrl}/platform/agentRoom/getPageByCondition`,

  // 预订记录
  getPageOrder: `${baseUrl}/platform/agentRoom/book/getPage`,

  // 房源列表
  getAgentRoomList: `${baseUrl}/platform/agentRoom/getList`,

  // 取消发布
  deleteAgentRoomByCodes: `${baseUrl}/platform/agentRoom/deleteAgentRoomByCodes`,

  // 看房记录
  getPageApplyVisitPark: `${baseUrl}/platform/agentRoom/getPageApplyVisitPark`,

  // 获取配置
  getConfig: `${baseUrl}/platform/agentConfig/get`,

  // 更新配置
  updateConfig: `${baseUrl}/platform/agentConfig/saveOrUpdate`,

  // 添加看房记录
  addRoomRecord: `${baseUrl}/platform/agentInspectionRoomRecord/add`,

  // 删除看房记录
  deleteRoomRecord: `${baseUrl}/platform/agentInspectionRoomRecord/delete`,

  // 看房记录分页
  getRoomRecordPage: `${baseUrl}/platform/agentInspectionRoomRecord/getPage`,

  // 消息接收人
  getResponsiblePersonList: `${baseUrl85}/person/getResponsiblePersonList`,

  // 查询接收人
  getAgentMessageReceiver: `${baseUrl}/platform/agentMessageReceiverConfig/getList`,

  // 修改接收人
  modifyAgentMessageReceiver: `${baseUrl}/platform/agentMessageReceiverConfig/saveOrUpdate`,

  // 查询宣传语
  getAgentPark: `${baseUrl}/platform/agentPark/get`,

  // 修改宣传语
  updateAgentPark: `${baseUrl}/platform/agentPark/update`,

  //房源预订
  orderHousingResources: `${baseUrl}/platform/agentRoom/book`,

  //取消房源预订
  disorderHousingResources: `${baseUrl}/platform/agentRoom/unbook`,

  // 获取跟进人列表
  getYqPersonList: `${baseUrl85}/person/getYqPersonList`
}

export { api }



// WEBPACK FOOTER //
// ./src/view/api/agent.js